var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"text-h5 primary--text mr-2"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"text-h6 d-flex align-center primary--text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }